/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private http: HttpClient) { }

  PostContact(body: any): Observable<any> {
    const headers = { 'Content-Type': 'application/json' };
    const url = 'https://api.campconnectpro.ca/contact-us';
    return this.http.post<any>(url, body, { headers })
  }
}
